import { useQuery, gql } from "@apollo/client";

import { ContractTemplate } from "./useInsertContractTemplate";

export const CONTRACT_TEMPLATE_FRAGMENT = gql`
  fragment ContractTemplateFragment on ContractTemplate {
    id
    slug
    title
    body
    signatories
  }
`;

export const GET_CONTRACT_TEMPLATE = gql`
  query getContractTemplate($id: ID!) {
    contractTemplate(id: $id) {
      ...ContractTemplateFragment
    }
  }
  ${CONTRACT_TEMPLATE_FRAGMENT}
`;

export default (options = {}) => {
  return useQuery<
    {
      viewer: {
        id: string;
        contractTemplate: ContractTemplate;
      };
    },
    { id: string }
  >(GET_CONTRACT_TEMPLATE, options);
};
